import type { Template } from "@/types";

export const SQ_06_H5_V1: Template[] = [
    {
        id: "sq-06-h5v1-01",
        name: "SQ 01 - H5V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h5_v1_01.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 54, y: 69, width: 387, height: 579, rotation: 0, imageRotation: 0 },
            { id: "2", x: 449, y: 69, width: 213, height: 139, rotation: 0, imageRotation: 0 },
            { id: "3", x: 449, y: 216, width: 213, height: 139, rotation: 0, imageRotation: 0 },
            { id: "4", x: 449, y: 363, width: 213, height: 139, rotation: 0, imageRotation: 0 },
            { id: "5", x: 449, y: 510, width: 213, height: 138, rotation: 0, imageRotation: 0 },
            { id: "6", x: 776, y: 159, width: 589, height: 399, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-06-h5v1-02",
        name: "SQ 02 - H5V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h5_v1_02.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 72, y: 143, width: 270, height: 432, rotation: 0, imageRotation: 0 },
            { id: "2", x: 350, y: 143, width: 295, height: 212, rotation: 0, imageRotation: 0 },
            { id: "3", x: 350, y: 363, width: 295, height: 212, rotation: 0, imageRotation: 0 },
            { id: "4", x: 801, y: 269, width: 576, height: 373, rotation: 0, imageRotation: 0 },
            { id: "5", x: 801, y: 75, width: 284, height: 186, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1093, y: 75, width: 284, height: 186, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h5v1-03",
        name: "SQ 03 - H5V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h5_v1_03.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 57, y: 159, width: 603, height: 399, rotation: 0, imageRotation: 0 },
            { id: "2", x: 774, y: 70, width: 389, height: 577, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1171, y: 70, width: 207, height: 139, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1171, y: 217, width: 207, height: 138, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1171, y: 363, width: 207, height: 138, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1171, y: 509, width: 207, height: 138, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h5v1-04",
        name: "SQ 04 - H5V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h5_v1_04.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 69, y: 141, width: 578, height: 435, rotation: 0, imageRotation: 0 },
            { id: "2", x: 787, y: 75, width: 285, height: 184, rotation: 0, imageRotation: 0 },
            { id: "3", x: 787, y: 267, width: 285, height: 183, rotation: 0, imageRotation: 0 },
            { id: "4", x: 787, y: 458, width: 285, height: 183, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1080, y: 458, width: 284, height: 183, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1080, y: 75, width: 284, height: 375, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h5v1-05",
        name: "SQ 05 - H5V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h5_v1_05.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 69, y: 141, width: 578, height: 435, rotation: 0, imageRotation: 0 },
            { id: "2", x: 855, y: 141, width: 217, height: 140, rotation: 0, imageRotation: 0 },
            { id: "3", x: 855, y: 289, width: 217, height: 140, rotation: 0, imageRotation: 0 },
            { id: "4", x: 855, y: 437, width: 217, height: 139, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1080, y: 437, width: 216, height: 139, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1080, y: 141, width: 216, height: 288, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h5v1-06",
        name: "SQ 06 - H5V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h5_v1_06.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 66, y: 185, width: 252, height: 170, rotation: 0, imageRotation: 0 },
            { id: "2", x: 66, y: 363, width: 252, height: 169, rotation: 0, imageRotation: 0 },
            { id: "3", x: 326, y: 185, width: 252, height: 170, rotation: 0, imageRotation: 0 },
            { id: "4", x: 326, y: 363, width: 252, height: 169, rotation: 0, imageRotation: 0 },
            { id: "5", x: 821, y: 185, width: 547, height: 347, rotation: 0, imageRotation: 0 },
            { id: "6", x: 586, y: 185, width: 227, height: 347, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h5v1-07",
        name: "SQ 07 - H5V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h5_v1_07.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 166, y: 94, width: 385, height: 261, rotation: 0, imageRotation: 0 },
            { id: "2", x: 166, y: 363, width: 189, height: 126, rotation: 0, imageRotation: 0 },
            { id: "3", x: 166, y: 497, width: 189, height: 126, rotation: 0, imageRotation: 0 },
            { id: "4", x: 363, y: 363, width: 188, height: 126, rotation: 0, imageRotation: 0 },
            { id: "5", x: 363, y: 497, width: 188, height: 126, rotation: 0, imageRotation: 0 },
            { id: "6", x: 883, y: 94, width: 386, height: 529, rotation: 0, imageRotation: 0 },
        ],
    },

    {
        id: "sq-06-h5v1-08",
        name: "SQ 08 - H5V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h5_v1_08.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 47, y: 94, width: 349, height: 529, rotation: 0, imageRotation: 0 },
            { id: "2", x: 404, y: 94, width: 189, height: 127, rotation: 0, imageRotation: 0 },
            { id: "3", x: 404, y: 229, width: 189, height: 126, rotation: 0, imageRotation: 0 },
            { id: "4", x: 404, y: 363, width: 189, height: 126, rotation: 0, imageRotation: 0 },
            { id: "5", x: 404, y: 497, width: 189, height: 126, rotation: 0, imageRotation: 0 },
            { id: "6", x: 601, y: 94, width: 786, height: 529, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h5v1-09",
        name: "SQ 09 - H5V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h5_v1_09.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 101, y: 480, width: 287, height: 185, rotation: 0, imageRotation: 0 },
            { id: "2", x: 101, y: 51, width: 287, height: 421, rotation: 0, imageRotation: 0 },
            { id: "3", x: 396, y: 51, width: 466, height: 303, rotation: 0, imageRotation: 0 },
            { id: "4", x: 396, y: 362, width: 466, height: 303, rotation: 0, imageRotation: 0 },
            { id: "5", x: 870, y: 51, width: 466, height: 303, rotation: 0, imageRotation: 0 },
            { id: "6", x: 870, y: 362, width: 466, height: 303, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "sq-06-h5v1-10",
        name: "SQ 10 - H5V1",
        albumType: "SQ",
        thumbnail: "/thumbnails/SQ/sq-06-h5_v1_10.png",
        size: [1434, 717],
        style: {},
        slots: [
            { id: "1", x: 80, y: 45, width: 305, height: 204, rotation: 0, imageRotation: 0 },
            { id: "2", x: 80, y: 257, width: 305, height: 204, rotation: 0, imageRotation: 0 },
            { id: "3", x: 80, y: 469, width: 305, height: 203, rotation: 0, imageRotation: 0 },
            { id: "4", x: 393, y: 44, width: 427, height: 629, rotation: 0, imageRotation: 0 },
            { id: "5", x: 888, y: 44, width: 466, height: 311, rotation: 0, imageRotation: 0 },
            { id: "6", x: 888, y: 363, width: 466, height: 310, rotation: 0, imageRotation: 0 }
        ],
    },
];

